import { type CollectionConfig, CollectionLayout, CollectionSlug } from '../collections.types';

const IMAGES = 'https://p1.liveauctioneers.com/dist/images/timeless-tabletop-treasures';

export const tabletopCollection: CollectionConfig = {
    breadcrumbs: [
        { href: '/c/home-and-decor/', label: 'Home & Decor' },
        { href: '', label: 'Tabletop' },
    ],
    description:
        'Discover fine silver, crystal and china from Tiffany & Co., Christofle, Baccarat, and English, French and Italian tabletop traditions.',
    layout: CollectionLayout.Collection,
    metaDescription:
        'Shop fine silver, crystal and china at auction — Tiffany & Co., Christofle, Baccarat and English, French and Italian tabletop from top auction houses worldwide.',
    searchParams: { category_id: '86' },
    seoTitle: 'Timeless Tabletop Treasures for Sale at Auction',
    slug: CollectionSlug.Tabletop,
    subcategories: [
        {
            href: '/search/?keyword=christofle&status=online',
            imageUrl: `${IMAGES}-christofle.png`,
            title: 'Christofle',
        },
        {
            href: '/search/?category_id=86&keyword=english&status=online',
            imageUrl: `${IMAGES}-english-tabletop.png`,
            title: 'English Tabletop',
        },
        {
            href: '/search/?category_id=86&keyword=tiffany&status=online',
            imageUrl: `${IMAGES}-tiffany-n-co.png`,
            title: 'Tiffany & Co.',
        },
        {
            href: '/search/?category_id=86&keyword=french&status=online',
            imageUrl: `${IMAGES}-french-tabletop.png`,
            title: 'French Tabletop',
        },
        {
            href: '/search/?category_id=86&keyword=baccarat&status=online',
            imageUrl: `${IMAGES}-baccarat.png`,
            title: 'Baccarat',
        },
        {
            href: '/search/?category_id=86&keyword=italian&sale_type=liveAuction&status=online',
            imageUrl: `${IMAGES}-italian-tabletop.png`,
            title: 'Italian Tabletop',
        },
    ],
    title: 'Set the Table with Timeless Tabletop Treasures',
};
